<div class="login-page">
  <img src="./assets/{{ logoFile }}" class="logo" alt="Imagine" height="80" width="250" />
  <div>Please wait......</div>
</div>
